import {useState} from 'react'
import {Modal, Button} from '@origamirisk/origami-storybook'
import {Tabs, Tab, Box, IconButton} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import {
    ExecutionTreeTab,
    LogsTab,
    ErrorLogsTab,
    RequestTab,
    OriginalProposalTab,
    GeneratedProposalTab,
    DetailsProposalTab,
    DataComparisonTab,
    TabPanel
} from './ProposalDetailsTabs'

interface ProposalDetailsModalProps {
    open: boolean
    onClose: () => void
    record: any
    onNext?: () => void
    onPrevious?: () => void
    hasNext?: boolean
    hasPrevious?: boolean
}

function ProposalDetailsModal({open, onClose, record, onNext, onPrevious, hasNext, hasPrevious}: ProposalDetailsModalProps) {
    const [tabIndex, setTabIndex] = useState(0)
    const hasDataComparison = !!record?.data?.responseS3?.dataComparison

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue)
    }

    const titleContent = (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
            {onPrevious && (
                <IconButton size="small" onClick={onPrevious} disabled={!hasPrevious}>
                    <ArrowBackIcon/>
                </IconButton>
            )}
            {onNext && (
                <IconButton size="small" onClick={onNext} disabled={!hasNext}>
                    <ArrowForwardIcon/>
                </IconButton>
            )}
            <span>Proposal Details - {record?.proposalId ?? ''}</span>
        </Box>
    )

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="lg"
            title={titleContent as any}
            actions={
                <Button color="secondary" variant="outlined" onClick={onClose}>
                    Close
                </Button>
            }
            sx={{
                '& .MuiDialog-paper': {
                    width: '90vw',
                    maxWidth: '90vw',
                    height: '90vh',
                    maxHeight: '90vh'
                }
            }}
        >
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={tabIndex} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                    <Tab label="Details"/>
                    <Tab label="Execution Tree"/>
                    <Tab label="Logs"/>
                    <Tab label="Error Logs"/>
                    <Tab label="Request"/>
                    <Tab label="Original Proposal"/>
                    <Tab label="Generated Proposal"/>
                    {hasDataComparison && <Tab label="Data Comparison"/>}
                </Tabs>
            </Box>
            <div style={{height: 'calc(90vh - 200px)', overflow: 'auto'}}>
                <TabPanel value={tabIndex} index={0}>
                    <DetailsProposalTab record={record}/>
                </TabPanel>
                <TabPanel value={tabIndex} index={1}>
                    <ExecutionTreeTab record={record}/>
                </TabPanel>
                <TabPanel value={tabIndex} index={2}>
                    <LogsTab record={record}/>
                </TabPanel>
                <TabPanel value={tabIndex} index={3}>
                    <ErrorLogsTab record={record}/>
                </TabPanel>
                <TabPanel value={tabIndex} index={4}>
                    <RequestTab record={record}/>
                </TabPanel>
                <TabPanel value={tabIndex} index={5}>
                    <OriginalProposalTab record={record}/>
                </TabPanel>
                <TabPanel value={tabIndex} index={6}>
                    <GeneratedProposalTab record={record}/>
                </TabPanel>
                {hasDataComparison && (
                    <TabPanel value={tabIndex} index={7}>
                        <DataComparisonTab record={record}/>
                    </TabPanel>
                )}
            </div>
        </Modal>
    )
}

export default ProposalDetailsModal
